import React from 'react'
import {
  BrowserRouter as Router,
  Routes, Route, useLocation, useRoutes, useParams
} from "react-router-dom";

import Signup from './Signup';
import Login from './Login';
import Forgotpass from './Forgotpass';
import Dashboard from './Dashboard';
import OptimizeImage from './OptimizeImage';
import History from './History';
import Layout from '../Components/Layout';
import BuyCredits from './BuyCredits';
import PaymentSuccess from '../Components/PaymentSuccess';
import Transactions from './Transactions';
import Settings from './Settings';
import Support from './Support';

const Mainroutes = () => {

  const token = localStorage.getItem('token')
  return (
    <div className="mobile-container">


      {/* {token && <>
        <Layout />
      </>} */}

      <Routes>

        {
          token ?



            (<Route element={<Layout />}>
              <Route path="/*" element={<Dashboard />} />
              <Route path="/optimize" element={<OptimizeImage />} />
              <Route path="/history" element={<History />} />
              <Route path="/buy" element={<BuyCredits />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/support" element={<Support />} />
              {/* <Route path="/settings" element={<Settings />} /> */}
            </Route>)
            :
            (<><Route path='/*' element={<Login />} />
        <Route path='/signup' element={<Signup />} />
        <Route path='/login' element={<Login />} />
        <Route path='/forgot' element={<Forgotpass />} />
            </>)
        }
      </Routes>
    </div>
  )
}

export default Mainroutes